/** Official Google G-mark SVGs — flat public paths (no spaces; Firebase Hosting 404s encoded folders). */
export const googleSignInAssets = {
  signInLight: '/signin-assets-google/web_light_rd_na.svg',
  signInDark: '/signin-assets-google/web_dark_rd_na.svg',
} as const;
